import { spinnerHtml } from './utilities.js';

export function _bootstrapComponent(element, componentName, options) {
    if (!window.bootstrap || !bootstrap[componentName] || typeof $ !== 'function') {
        return null;
    }

    var elementInstance = element instanceof jQuery ? element[0] : element;
    var getInstance = bootstrap[componentName].getOrCreateInstance;

    if (typeof getInstance !== 'function') {
        return null;
    }

    return getInstance.call(bootstrap[componentName], elementInstance, options || {});
}

export function initTooltip($element, options) {
    return _bootstrapComponent($element, 'Tooltip', options);
}

export function showTooltip($element) {
    var tooltip = initTooltip($element);

    if (tooltip && typeof tooltip.show === 'function') {
        tooltip.show();
    }
}

export function hideTooltip($element) {
    var tooltip = initTooltip($element);

    if (tooltip && typeof tooltip.hide === 'function') {
        tooltip.hide();
    }
}

export function disposeTooltip($element) {
    var tooltip = initTooltip($element);

    if (tooltip && typeof tooltip.dispose === 'function') {
        tooltip.dispose();
    }
}

export function updateTooltipTitle($element, message) {
    var tooltip = initTooltip($element);

    if (!tooltip) {
        return;
    }

    $element.attr('data-bs-title', message);

    if (typeof tooltip.setContent === 'function') {
        tooltip.setContent({ '.tooltip-inner': message });
        return;
    }

    tooltip._config.title = message;
}

export function initPopover($element, options) {
    return _bootstrapComponent($element, 'Popover', options);
}

export function showPopover($element) {
    var popover = initPopover($element);

    if (popover && typeof popover.show === 'function') {
        popover.show();
    }
}

export function hidePopover($element) {
    var popover = initPopover($element);

    if (popover && typeof popover.hide === 'function') {
        popover.hide();
    }
}

export function disposePopover($element) {
    var popover = initPopover($element);

    if (popover && typeof popover.dispose === 'function') {
        popover.dispose();
    }
}

export function updatePopoverContent($element, content) {
    var popover = initPopover($element);

    if (!popover) {
        return null;
    }

    if (typeof popover.setContent === 'function') {
        popover.setContent();
        return popover;
    }

    if (typeof popover.update === 'function') {
        popover.update();
        return popover;
    }

    return popover;
}

export function getTab($element) {
    return _bootstrapComponent($element, 'Tab');
}

export function showTab($element) {
    var tab = getTab($element);

    if (tab && typeof tab.show === 'function') {
        tab.show();
    }
}

export function getModal($element) {
    return _bootstrapComponent($element, 'Modal');
}

export function showModal($element, options) {
    var modal = _bootstrapComponent($element, 'Modal', options);

    if (modal && typeof modal.show === 'function') {
        modal.show();
    }

    return modal;
}

export function hideModal($element) {
    var modal = getModal($element);

    if (modal && typeof modal.hide === 'function') {
        modal.hide();
    }

    return modal;
}

export function toggleModal($element) {
    var modal = getModal($element);

    if (modal && typeof modal.toggle === 'function') {
        modal.toggle();
    }
}

export function setButtonLoading($element, message) {
    if (!$element || !$element.length) {
        return;
    }

    if (typeof $element.data('bs-original-html') === 'undefined') {
        $element.data('bs-original-html', $element.html());
    }

    $element
        .prop('disabled', true)
        .html(
            spinnerHtml(message || 'Loading...')
        );
}

export function resetButtonState($element) {
    if (!$element || !$element.length) {
        return;
    }

    var original = $element.data('bs-original-html');

    if (typeof original !== 'undefined') {
        $element.html(original);
    }

    $element.prop('disabled', false);
}

export function initPopovers() {
    $('[data-bs-toggle="popover"]').each(function () {
        initPopover($(this));
    });
}
